import { render, staticRenderFns } from "./group-folder.vue?vue&type=template&id=f8f0728e&scoped=true"
import script from "./group-folder.vue?vue&type=script&lang=ts"
export * from "./group-folder.vue?vue&type=script&lang=ts"
import style0 from "./group-folder.vue?vue&type=style&index=0&id=f8f0728e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f0728e",
  null
  
)

export default component.exports